import {
    fetchArticleBody,
    fetchOddsChange,
    // fetchRelative,
    // fetchComments,
} from '../api';

export default {

    FETCH_ARTICLEBODY: ({ commit, state }, { article_id }) => {
        // articleId接收自页面组件asyncData的store.dispatch
        return state.articlebody[article_id]
            ? Promise.resolve(state.articlebody[article_id])
            : fetchArticleBody(article_id).then(_articlebody => commit('SET_ARTICLEBODY', {
                articleId: article_id,
                _articlebody
            }));
    },
    FETCH_ODDSCHANGE: ({ commit, state }, options) => {
        // articleId接收自页面组件asyncData的store.dispatch
        return state.oddsChange.length > 0
            ? Promise.resolve(state.oddsChange)
            : fetchOddsChange(options).then(_oddsChange => commit('SET_ODDSCHANGE', {
                ...options,
                _oddsChange
            }));
    },
    // FETCH_RELATIVE: ({ commit, state }, { relative}) => {
    //   return state.relative[articleId]
    //     ? Promise.resolve(state.relative[articleId])
    //     : fetchRelative(articleId).then(_relative => commit('SET_RELATIVE', { articleId,_relative }))
    // },
    // FETCH_COMMENTS: ({ commit, state }, { comments}) => {
    //   // console.log((new Promise).resolve(fetchArticleBody(articleId)))
    //   return state.comments[articleId]
    //     ? Promise.resolve(state.comments[articleId])
    //     : fetchComments(articleId).then(_comments => commit('SET_COMMENTS', { articleId,_comments }))
    // }
};



// WEBPACK FOOTER //
// ./src/store/actions.js